import React from 'react';
import { IconProps, IconComponent } from './types';
import {
  registerIcon,
  registerIcons,
  getCustomIcon,
  hasCustomIcon,
  getCustomIconNames,
  resolveIconColor,
} from '../../config/icon-registry';

// Import all icons from individual files
import { AlertTriangleIcon } from './alert-triangle';
import { AlignBottomIcon } from './align-bottom';
import { AlignCenterIcon } from './align-center';
import { AlignLeftIcon } from './align-left';
import { AlignMiddleIcon } from './align-middle';
import { AlignRightIcon } from './align-right';
import { AlignTopIcon } from './align-top';
import { AreaOcrIcon } from './areaOcr'
import { ArrowBackUpIcon } from './arrow-back-up';
import { ArrowForwardUpIcon } from './arrow-forward-up';
import { BoldIcon } from './bold';
import { BookIcon } from './book';
import { Book2Icon } from './book2';
import { CalloutIcon } from './callout';
import { CheckIcon } from './check';
import { ChevronDownIcon } from './chevron-down';
import { ChevronLeftIcon } from './chevron-left';
import { ChevronRightIcon } from './chevron-right';
import { CircleIcon } from './circle';
import { CommentIcon } from './comment';
import { CopyIcon } from './copy';
import { DeviceFloppyIcon } from './device-floppy';
import { DotsIcon } from './dots';
import { DoublePageIcon } from './double-page';
import { DownloadIcon } from './download';
import { ExternalLinkIcon } from './external-link';
import { EyeOffIcon } from './eye-off';
import { EyeIcon } from './eye';
import { FileImportIcon } from './file-import';
import { FileIcon } from './file';
import { FitToPageIcon } from './fit-to-page';
import { FitToWidthIcon } from './fit-to-width';
import { FormCheckboxIcon } from './form-checkbox';
import { FormListboxIcon } from './form-listbox';
import { FormRadioIcon } from './form-radio';
import { FormSelectIcon } from './form-select';
import { FormTextfieldIcon } from './form-textfield';
import { FreeTextIcon } from './free-text';
import { FullscreenExitIcon } from './fullscreen-exit';
import { FullscreenIcon } from './fullscreen';
import { GroupIcon } from './group';
import { HandIcon } from './hand';
import { HighlightIcon } from './highlight';
import { HorizontalIcon } from './horizontal';
import { InfoIcon } from './info';
import { InkHighlighterIcon } from './ink-highlighter';
import { InsertTextIcon } from './insert-text';
import { ItalicIcon } from './italic';
import { LineArrowIcon } from './line-arrow';
import { LineIcon } from './line';
import { LinkOffIcon } from './link-off';
import { LinkIcon } from './link';
import { ListTreeIcon } from './list-tree';
import { LockIcon } from './lock';
import { MarqueeSelectIcon } from './marquee-select';
import { MenuIcon } from './menu';
import { MessageIcon } from './message';
import { PaletteIcon } from './palette';
import { PageOcrIcon } from './pageOcr';
import { PaperclipIcon } from './paperclip';
import { PencilMarkerIcon } from './pencil-marker';
import { PhotoIcon } from './photo';
import { PlusIcon } from './plus';
import { PointerIcon } from './pointer';
import { PolygonIcon } from './polygon';
import { PrintIcon } from './print';
import { RedactAreaIcon } from './redact-area';
import { RedactCombinedIcon } from './redact-combined';
import { RedactIcon } from './redact';
import { RedactionSidebarIcon } from './redaction-sidebar';
import { ReplaceTextIcon } from './replace-text';
import { RotateClockwiseIcon } from './rotate-clockwise';
import { RotateCounterClockwiseIcon } from './rotate-counter-clockwise';
import { RubberStampPlusIcon } from './rubber-stamp-plus';
import { RubberStampIcon } from './rubber-stamp';
import { SaveIcon } from './save';
import { SaveAllIcon } from './saveAll';
import { ScanAreaIcon } from './scan-area';
import { ScanTextIcon } from './scan-text';
import { ScreenshotIcon } from './screenshot';
import { SearchIcon } from './search';
import { SettingsIcon } from './settings';
import { SidebarIcon } from './sidebar';
import { SignatureIcon } from './signature';
import { SinglePageIcon } from './single-page';
import { SquareIcon } from './square';
import { SquaresIcon } from './squares';
import { SquigglyIcon } from './squiggly';
import { StrikethroughIcon } from './strikethrough';
import { TextIcon } from './text';
import { TrashIcon } from './trash';
import { UnderlineIcon } from './underline';
import { UngroupIcon } from './ungroup';
import { UnlockIcon } from './unlock';
import { VerticalIcon } from './vertical';
import { ViewSettingsIcon } from './view-settings';
import { WidgetEditIcon } from './widget-edit';
import { XIcon } from './x';
import { ZigzagIcon } from './zigzag';
import { ZoomInAreaIcon } from './zoom-in-area';
import { ZoomInIcon } from './zoom-in';
import { ZoomOutIcon } from './zoom-out';

export type {
  IconProps as IconComponentProps,
  IconComponent,
  IconPathConfig,
  CustomIconConfig,
  SimpleIconConfig,
} from './types';

export {
  registerIcon,
  registerIcons,
  getCustomIcon,
  hasCustomIcon,
  getCustomIconNames,
  resolveIconColor,
};

export {
  AlertTriangleIcon,
  AlignBottomIcon,
  AlignCenterIcon,
  AlignLeftIcon,
  AlignMiddleIcon,
  AlignRightIcon,
  AlignTopIcon,
  ArrowBackUpIcon,
  ArrowForwardUpIcon,
  BoldIcon,
  BookIcon,
  Book2Icon,
  CalloutIcon,
  CheckIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  CircleIcon,
  CommentIcon,
  CopyIcon,
  DeviceFloppyIcon,
  DotsIcon,
  DoublePageIcon,
  DownloadIcon,
  ExternalLinkIcon,
  EyeOffIcon,
  EyeIcon,
  FileImportIcon,
  FileIcon,
  FitToPageIcon,
  FitToWidthIcon,
  FormCheckboxIcon,
  FormListboxIcon,
  FormRadioIcon,
  FormSelectIcon,
  FormTextfieldIcon,
  FreeTextIcon,
  FullscreenExitIcon,
  FullscreenIcon,
  GroupIcon,
  HandIcon,
  HighlightIcon,
  HorizontalIcon,
  InfoIcon,
  InkHighlighterIcon,
  InsertTextIcon,
  ItalicIcon,
  LineArrowIcon,
  LineIcon,
  LinkOffIcon,
  LinkIcon,
  ListTreeIcon,
  LockIcon,
  MarqueeSelectIcon,
  MenuIcon,
  MessageIcon,
  PaletteIcon,
  PaperclipIcon,
  PencilMarkerIcon,
  PhotoIcon,
  PlusIcon,
  PointerIcon,
  PolygonIcon,
  PrintIcon,
  RedactAreaIcon,
  RedactCombinedIcon,
  RedactIcon,
  RedactionSidebarIcon,
  ReplaceTextIcon,
  RotateClockwiseIcon,
  RotateCounterClockwiseIcon,
  RubberStampPlusIcon,
  RubberStampIcon,
  SaveAllIcon,
  SaveIcon,
  ScreenshotIcon,
  SearchIcon,
  SettingsIcon,
  SidebarIcon,
  SignatureIcon,
  SinglePageIcon,
  SquareIcon,
  SquaresIcon,
  SquigglyIcon,
  StrikethroughIcon,
  TextIcon,
  TrashIcon,
  UnderlineIcon,
  UngroupIcon,
  UnlockIcon,
  VerticalIcon,
  ViewSettingsIcon,
  WidgetEditIcon,
  XIcon,
  ZigzagIcon,
  ZoomInAreaIcon,
  ZoomInIcon,
  ZoomOutIcon,
};

/**
 * Registry of all built-in icons
 */
export const icons: Record<string, IconComponent> = {
  alertTriangle: AlertTriangleIcon,
  alignBottom: AlignBottomIcon,
  alignCenter: AlignCenterIcon,
  alignLeft: AlignLeftIcon,
  alignMiddle: AlignMiddleIcon,
  alignRight: AlignRightIcon,
  alignTop: AlignTopIcon,
  areaOcr: AreaOcrIcon,
  arrowBackUp: ArrowBackUpIcon,
  arrowForwardUp: ArrowForwardUpIcon,
  bold: BoldIcon,
  book: BookIcon,
  book2: Book2Icon,
  callout: CalloutIcon,
  check: CheckIcon,
  chevronDown: ChevronDownIcon,
  chevronLeft: ChevronLeftIcon,
  chevronRight: ChevronRightIcon,
  circle: CircleIcon,
  comment: CommentIcon,
  copy: CopyIcon,
  deviceFloppy: DeviceFloppyIcon,
  dots: DotsIcon,
  doublePage: DoublePageIcon,
  download: DownloadIcon,
  externalLink: ExternalLinkIcon,
  eyeOff: EyeOffIcon,
  eye: EyeIcon,
  fileImport: FileImportIcon,
  file: FileIcon,
  fitToPage: FitToPageIcon,
  fitToWidth: FitToWidthIcon,
  formCheckbox: FormCheckboxIcon,
  formListbox: FormListboxIcon,
  formRadio: FormRadioIcon,
  formSelect: FormSelectIcon,
  formTextfield: FormTextfieldIcon,
  freeText: FreeTextIcon,
  fullscreenExit: FullscreenExitIcon,
  fullscreen: FullscreenIcon,
  group: GroupIcon,
  hand: HandIcon,
  highlight: HighlightIcon,
  horizontal: HorizontalIcon,
  info: InfoIcon,
  inkHighlighter: InkHighlighterIcon,
  insertText: InsertTextIcon,
  italic: ItalicIcon,
  lineArrow: LineArrowIcon,
  line: LineIcon,
  linkOff: LinkOffIcon,
  link: LinkIcon,
  listTree: ListTreeIcon,
  lock: LockIcon,
  marqueeSelect: MarqueeSelectIcon,
  menu: MenuIcon,
  message: MessageIcon,
  palette: PaletteIcon,
  pageOcr: PageOcrIcon,
  paperclip: PaperclipIcon,
  pencilMarker: PencilMarkerIcon,
  photo: PhotoIcon,
  plus: PlusIcon,
  pointer: PointerIcon,
  polygon: PolygonIcon,
  print: PrintIcon,
  redactArea: RedactAreaIcon,
  redactCombined: RedactCombinedIcon,
  redact: RedactIcon,
  redactionSidebar: RedactionSidebarIcon,
  replaceText: ReplaceTextIcon,
  rotateClockwise: RotateClockwiseIcon,
  rotateCounterClockwise: RotateCounterClockwiseIcon,
  rubberStampPlus: RubberStampPlusIcon,
  rubberStamp: RubberStampIcon,
  save: SaveIcon,
  saveAll: SaveAllIcon,
  screenshot: ScreenshotIcon,
  scanArea: ScanAreaIcon,
  scanText: ScanTextIcon,
  search: SearchIcon,
  settings: SettingsIcon,
  sidebar: SidebarIcon,
  signature: SignatureIcon,
  singlePage: SinglePageIcon,
  square: SquareIcon,
  squares: SquaresIcon,
  squiggly: SquigglyIcon,
  strikethrough: StrikethroughIcon,
  text: TextIcon,
  trash: TrashIcon,
  underline: UnderlineIcon,
  ungroup: UngroupIcon,
  unlock: UnlockIcon,
  vertical: VerticalIcon,
  viewSettings: ViewSettingsIcon,
  widgetEdit: WidgetEditIcon,
  x: XIcon,
  zigzag: ZigzagIcon,
  zoomInArea: ZoomInAreaIcon,
  zoomIn: ZoomInIcon,
  zoomOut: ZoomOutIcon,
};
